import { browserLocalPersistence, setPersistence } from "firebase/auth";
let persistencePromise = null;

export const ensurePersistence = (auth) => {
  if (!persistencePromise) {
    persistencePromise = setPersistence(auth, browserLocalPersistence)
      .then(() => true)
      .catch((error) => {
        console.warn(
          "[dealer auth] LOCAL persistence unavailable; continuing with Firebase fallback:",
          error?.code || error?.message || error
        );
        persistencePromise = null;
        return false;
      });
  }

  return persistencePromise;
};
